<template>
    <div id="ContractMiscellaneousChargeTabView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="formOpen==false">

            <div class="table-responsive-sm" v-if="chargesArr && chargesArr.length > 0">
                <div class="form-row row-cols-md-4 row-cols-1">
                    <div class="col form-group">
                        <label class="control-label">Charge Date:</label>
                        <label class="control-label">{{charge_date}}</label>
                    </div>
                </div>
                <table aria-describedby="table" id="" class="table table-sm table-bordered font-1">
                    <thead>
                        <tr class="table-primary">
                            <th>Charge</th>
                            <th class="text-right">From Date</th>
                            <th class="text-right">To Date</th>
                            <th class="text-right">Quantity</th>
                            <th class="text-right">Rate</th>
                            <th class="text-right">Amount</th>
                            <th>Status</th>
                            <th>Comments</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="chargesArr && chargesArr.length > 0">
                            <template v-for="(record, index) in chargesArr">
                                <tr v-bind:key="'recordRow'+index">
                                    <td>{{record.charge_name}} ( {{record.charge_identifier}} )</td>
                                    <td>{{record.misc_charge_date}}</td>
                                    <td>{{record.misc_charge_to_date}}</td>
                                    <td class="text-right">{{record.quantity.toFixed(2)}}</td>
                                    <td class="text-right">${{record.rate.toFixed(2)}}</td>
                                    <td class="text-right">${{record.amount.toFixed(2)}}</td>
                                    <td><template v-if="record.status==1">Billed
                                        </template>
                                        <template v-else>Not - Billed
                                        </template>
                                    </td>
                                    <td>{{record.comment}}</td>
                                </tr>
                            </template>
                        </template>
                        <template v-else>
                            <tr><td colspan="5" class="text-center">No Record Found</td></tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div v-else>No Data Found.</div>
        </template>
        <template v-else>
            <div class="form-row row-cols-md-4 row-cols-1" v-if="!fromReturn">
                <div class="col form-group">
                    <label class="control-label require">Charge Date:</label>
                    <div class="input-group">
                        <date-picker placeholder="MM/DD/YYYY" id="charge_date" name="charge_date" v-model="charge_date" :config="optionsChargeDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                        <label for="charge_date" class="fp-calendar input-calender-icon"></label>
                    </div>
                    <div class="field-error">{{charge_date_error_msg}}</div>
                </div>
            </div>
             <!-- <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title " id="ContractAssetDetailForm"> -->
                <!-- <div class="alert-contract field-error hide"></div> -->
                <!-- <div class="row">
                    <div class="col-md-2 form-group">
                        <label class="control-label require" for="section.id">Charge:</label>
                    </div>
                     <div class="col-md-2 form-group">
                        <label class="control-label require" for="section.id">Date:</label>
                    </div>
                    <div class="col-md-2 form-group">
                        <label class="control-label require" for="section_value">Quantity:</label>
                    </div>
                    <div class="col-md-2 form-group require">
                        <label class="control-label" for="section_value">Rate:</label>
                    </div>
                    <div class="col-md-2 form-group">
                        <label class="control-label" for="section_value">Amount:</label>
                    </div>

                    <div class="col-md-2 form-group">
                        <label class="control-label" for="section_value">Comments:</label>
                    </div>
                </div> -->
                <!-- <div class="row" v-for="(charge, index) in chargesArrInput" v-bind:key="index">
                    <input type="hidden" class="form-control" v-model="charge.id" placeholder="" name="rate_id">
                    <div class="col-md-2 form-group">
                        <v-select class="section-id" :disabled="charge.status == '1' || charge.isDisable === true" v-model="charge.charge" name="charge" @input="onchangeCharge($event,charge.charge,index)" placeholder="Select charge"
                                    label="text"
                                    :options="contractChargesArr">
                        </v-select>
                        <div class="field-error">{{ charge.charge_error_msg }}</div>
                    </div>
                    <div class="col-md-2 form-group">
                         <date-picker placeholder="MM/DD/YYYY" format="MM/DD/YYYY" id="misc_charge_date" :disabled="charge.status == '1' || charge.isDisable" name="misc_charge_date" v-model="charge.misc_charge_date" :config="options" ></date-picker>
                         <label for="misc_charge_date"></label>
                         <div class="field-error">{{ charge.charge_date_error_msg }}</div>
                    </div>
                    <div class="col-md-2 form-group">
                        <input type="text" ref="infoBox" :disabled="charge.status == '1' || charge.isDisable" class="form-control text-right" v-model="charge.quantity"  @input="calculateAmount(index)" id="quantity" placeholder="Add Quantity" name="quantity" aria-describedby="basic-addon3" @keypress="isAmountCheck($event)">
                        <div class="field-error">{{ charge.quantity_error_msg }}</div>
                    </div>
                    <div class="col-md-2 form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text">$</div>
                            </div>
                            <input type="text" :disabled="charge.status == '1' || charge.isDisable" ref="infoBox" class="form-control text-right" v-model="charge.rate"  @input="calculateAmount(index)" id="section_value" placeholder="Add Rate " name="rate" aria-describedby="basic-addon3" @keypress="isAmountCheck($event)">
                        </div>
                        <div class="field-error">{{ charge.rate_error_msg }}</div>
                    </div>
                    <div class="col-md-2 form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text">$</div>
                            </div>
                            <input type="text" ref="infoBox"  class="form-control text-right" disabled v-model="charge.amount" id="section_value" placeholder="Add Amount " name="amount" aria-describedby="basic-addon3" >
                        </div>
                        <div class="field-error">{{ charge.amount_error_msg }}</div>
                    </div>
                      <div class="col-md-2 form-group">
                        <textarea class='form-control' :disabled="charge.status == '1'" v-model="charge.comment" ref="textarea" placeholder="Add Comment" id="comment"  name="comment" aria-describedby="basic-addon3"></textarea>
                        <label class="checkbox-custom">
                          <input type="checkbox" v-model="charge.view_comment" id="view_comment" name="view_comment">
                            Show Comment in Invoice
                        </label>

                    </div>
                     <div class="col-md-2 form-group">
                        <template>
                            <a href="" class="fp-remove" :disabled="charge.isDisable === true" v-on:click.prevent="removeLine(index,charge.id, charge.status)"></a>
                        </template>
                        <label>&nbsp;&nbsp;</label>
                        <template>
                            <a href="" class="fp-plus" v-if="index + 1 === chargesArrInput.length  && chargesArrInput.length<5 " v-on:click.prevent="addLine($event,index)"></a>
                        </template>
                    </div>
                </div> -->

                <!-- <div class="web-action-btn btn-groups text-right" v-if="!fromReturn">
                    <button type='button' id="updateChargeButton1" title="Edit Cahrge" class="btn btn-primary"  v-on:click="createMiscCharge('')">
                        <i class="fp-save"> </i>   Save </button>
                    <button type='button'  title="Cancle Charge" class="btn btn-tertiary"  v-on:click="backChargeList()">
                        <i class="fp-close"> </i> Cancel</button>
                </div> -->

            <!-- </form> -->
            <table aria-describedby="table" id="customer-invoice-line-items-tbl" class="table table-sm table-bordered font-1">
                <thead>
                    <tr class="table-primary">
                        <th scope="col" style="width:80px" class="require">Charge</th>
                        <th scope="col" style="width:100px" class="require">From Date</th>
                        <th scope="col" style="width:100px" class="require">To Date</th>
                        <th scope="col" style="width:60px" class="require">Quantity</th>
                        <th scope="col" style="width:100px" class="require">Rate</th>
                        <th scope="col" style="width:120px" class="require">Amount</th>
                        <th scope="col" style="width:160px" class="require">Comments</th>
                        <th scope="col" style="width:50px"> Action </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(charge, index) in chargesArrInput" :key="index">
                        <td style="width:250px">
                          <v-select class="section-id" :disabled="charge.status == '1' || charge.isDisable === true" v-model="charge.charge" name="charge" @input="onchangeCharge($event,charge.charge,index)" placeholder="Select charge"
                            label="text"
                            :options="contractChargesArr">
                          </v-select>
                          <div class="field-error">{{ charge.charge_error_msg }}</div>

                        </td>
                        <td>
                          <div class="input-group">
                            <date-picker placeholder="MM/DD/YYYY" format="MM/DD/YYYY" id="misc_charge_date" :disabled="charge.status == '1' || charge.isDisable" name="misc_charge_date" v-model="charge.misc_charge_date" :config="options" ></date-picker>
                            <label for="misc_charge_date"></label>
                            <div class="field-error">{{ charge.charge_date_error_msg }}</div>
                            </div>
                        </td>
                        <td>
                          <div class="input-group">
                            <date-picker placeholder="MM/DD/YYYY" format="MM/DD/YYYY" id="misc_charge_to_date" :disabled="charge.status == '1' || charge.isDisable" name="misc_charge_to_date" v-model="charge.misc_charge_to_date" :config="options" ></date-picker>
                            <label for="misc_charge_to_date"></label>
                            <div class="field-error">{{ charge.charge_to_date_error_msg }}</div>
                            </div>
                        </td>
                        <td>
                          <input type="text" ref="infoBox" :disabled="charge.status == '1' || charge.isDisable" class="form-control text-right" v-model="charge.quantity"  @input="calculateAmount(index)" id="quantity" placeholder="Add Quantity" name="quantity" aria-describedby="basic-addon3" @keypress="isAmountCheck($event)">
                          <div class="field-error">{{ charge.quantity_error_msg }}</div>
                        </td>
                        <td>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">$</div>
                                </div>
                                <input type="text" :disabled="charge.status == '1' || charge.isDisable" ref="infoBox" class="form-control text-right" v-model="charge.rate"  @input="calculateAmount(index)" id="section_value" placeholder="Add Rate " name="rate" aria-describedby="basic-addon3" @keypress="isAmountCheck($event)">
                            </div>
                            <div class="field-error">{{ charge.rate_error_msg }}</div>
                        </td>
                        <td>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">$</div>
                                </div>
                                <input type="text" ref="infoBox"  class="form-control text-right" disabled v-model="charge.amount" id="section_value" placeholder="Add Amount " name="amount" aria-describedby="basic-addon3" >
                            </div>
                            <div class="field-error">{{ charge.amount_error_msg }}</div>
                        </td>
                        <td>
                          <textarea class='form-control' rows="1" :disabled="charge.status == '1'" v-model="charge.comment" ref="textarea" placeholder="Add Comment" id="comment"  name="comment" aria-describedby="basic-addon3"></textarea>
                          <label class="checkbox-custom">
                            <input type="checkbox" v-model="charge.view_comment" id="view_comment" name="view_comment">
                              Show Comment in Invoice
                          </label>
                        </td>
                        <td class="text-center valign-middle">
                            <template>
                                <a href="" class="fp-remove" :disabled="charge.isDisable === true" v-on:click.prevent="removeLine(index,charge.id, charge.status)"></a>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
             <div class="btn-groups">
              <button type="submit"  v-if="chargesArrInput.length<20" v-on:click.prevent="addLine()" class="btn btn-primary">
                  <i class="fp-add"></i>Add Charge
              </button>

            </div>
            <hr class="light-hr"/>
            <div class="web-action-btn btn-groups text-right" v-if="!fromReturn">
                    <button type='button' id="updateChargeButton1" title="Edit Cahrge" class="btn btn-primary"  v-on:click="createMiscCharge('')">
                        <i class="fp-save"> </i>   Save </button>
                    <button type='button'  title="Cancle Charge" class="btn btn-tertiary"  v-on:click="backChargeList()">
                        <i class="fp-close"> </i> Cancel</button>
            </div>
        </template>
        <!-- <template v-if="isClosed==0"> -->
        <template>
            <div class="btn-groups text-right mb-4">
                <Span class="alert-success" v-show="formOpen==false && notBilled && ($parent.alreadyBilled == 'yes' || from == 'agreement') && !fromReturn">Note: If you will not generate invoice, It will be billed in next invoice.</Span>
                <button title="Edit Asset"  v-show="formOpen==false && notBilled && ($parent.alreadyBilled == 'yes' || from == 'agreement') && !fromReturn" id="generateInvoiceBtn" class="btn btn-primary"  v-on:click.prevent="generateInvoice()">
                    <i class="fp-invoice-icon"> </i> Generate Invoice
                </button>
                <template v-if="chargeFound==true">
                    <button title="Edit Asset" id="updateChargeButton" v-if="formOpen==false" class="btn btn-primary"  v-on:click="loadCharge('update')">
                        <i class="fp-edit-icon"> </i> Update
                    </button>
                </template>
                <template v-else>
                    <button title="Edit Asset"  v-if="formOpen==false" class="btn btn-primary"  v-on:click="loadCharge('add')">
                        <i class="fp-add"> </i> Add
                    </button>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
    import {commonMixins} from '../mixins/commonMixins';
    import {contractMixins} from '../mixins/contractMixins';
    import moment from 'moment';
    export default {
        name: "ContractMiscellaneousChargeTabView",
        mixins:[commonMixins,contractMixins],
        props: {
            from: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            loading:false,
            contractChargesArr:[],
            chargesArr: [],
            chargesArrInput: [],
            isupdate:false,
            blockRemoval: true,
            close:false,
            rows:null,
            isClosed:0,
            chargeFound:false,
            formOpen:false,
            alreadyCharged:false,
            type:'',
            notBilled:false,
            fromReturn:false,
            options: {
                format: 'MM/DD/YYYY',
                useCurrent: false
            },
            charge_date_error_msg:'',
            charge_date:'',
            optionsChargeDate: {
                format: 'MM/DD/YYYY',
                useCurrent: true,
            },
        }),
        created: function() {

        },
        watch:{
            chargesArrInput() {
                var self = this;
                self.blockRemoval = self.chargesArrInput.length <= 1
            },
        },
        beforeDestroy(){
            this.$root.$off('returned');
        },
        mounted: function() {

            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.loadFieldData(['contract_misc_charges']);
            self.loadChargeData('','');
            setTimeout(function(){
              self.isClosed= self.$parent.closed;
            //   self.formOpen=false;
            },500)
            this.$root.$on("returned",(value)=>{
                self.loadChargeData('returned','return');
                self.isClosed = 1;
            });

        },
        methods: {
            backChargeList(){
                self=this;
                self.formOpen=false;
                self.loadChargeData('','');
                self.chargesArrInput=[];
            },
            calculateAmount(index){
                var self = this;
                if(self.chargesArrInput[index].quantity != null && self.chargesArrInput[index].quantity != "" && self.chargesArrInput[index].quantity != 0
                && self.chargesArrInput[index].rate != null && self.chargesArrInput[index].rate != "" && self.chargesArrInput[index].rate != 0){

                    if (self.chargesArrInput[index].charge.identifier != null && (self.chargesArrInput[index].charge.identifier.toLowerCase() == 'early' || self.chargesArrInput[index].charge.identifier.toLowerCase() == 'fix')){
                        var calRate = self.chargesArrInput[index].rate / 30;
                        self.chargesArrInput[index].amount = calRate * self.chargesArrInput[index].quantity;
                    }else{
                        self.chargesArrInput[index].amount=self.chargesArrInput[index].quantity * self.chargesArrInput[index].rate;
                    }
                }

            },
            loadChargeData(exp,frm){

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading=true;
                var expVar = '';
                if (exp == 'returned'){
                    expVar = 'returned';
                }
                if (exp != '' && exp != 'returned'){
                    self.fromReturn = true;
                }else if(self.$parent.expiry_date != undefined && self.$parent.expiry_date != ''){
                    self.fromReturn = true;
                    exp = self.$parent.expiry_date;
                }

                $.ajax({
                    url: process.env.ROOT_API + "/get-contract-asset-miscellaneous-charges",
                    type: "POST",
                    data: {"contract_asset_id":segments[3],
                    flag:self.from,exp:exp},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if (data.status == "success") {

                               self.chargesArr=data.content;
                               self.chargesArrInput=data.content;
                               if (self.chargesArr[0] && self.chargesArr[0].status == '1'){
                                   self.alreadyCharged = true;
                               }
                               self.chargeFound=true;

                               if (self.chargesArr && self.chargesArr.length > 0){
                                   var alBilled = 1;
                                   for(var i =0;i<self.chargesArr.length;i++){
                                       self.chargesArr[i].misc_charge_date = moment(self.chargesArr[i].misc_charge_date).format('MM/DD/YYYY');
                                       self.chargesArr[i].misc_charge_to_date = moment(self.chargesArr[i].misc_charge_to_date).format('MM/DD/YYYY');
                                    // self.chargesArr[i].misc_charge_date = exp;
                                        self.chargesArr[i].charge = {text:self.chargesArr[i].charge_name,value:self.chargesArr[i].charge_id};
                                       if (self.chargesArr[i].status == '0'){
                                           alBilled = 0;
                                       }
                                   }
                                   if (alBilled == 0){
                                       self.notBilled = true;
                                   }else{
                                       self.notBilled = false;
                                   }
                               }
                               if (data.charge_date != undefined){
                                    self.charge_date = data.charge_date;
                               }else{
                                    self.charge_date = moment().format('MM/DD/YYYY');
                               }
                        }else if(data.status=='not_found'){
                            self.chargesArr = [];
                            self.chargesArrInput = [];
                            if (self.fromReturn == false && self.$parent.closed != 1){
                                self.chargesArrInput.push({
                                    id:0,
                                    charge:null,
                                    misc_charge_date : "",
                                    misc_charge_to_date : "",
                                    charge_to_date_error_msg:'',
                                    view_comment:false,
                                    quantity:0,
                                    rate:0,
                                    amount:0,
                                    comment:"",
                                    charge_error_msg: "",
                                    quantity_error_msg: "",
                                    rate_error_msg: "",
                                    amount_error_msg: "",
                                    status:'0',
                                    isDisable:false
                                })
                            }
                            self.charge_date = moment().format('MM/DD/YYYY');
                        }

                        if (data.contract_charge[0] && data.contract_charge[0].charge_id != undefined){
                            // var contract_charge = data.contract_charge;
                            if (self.$parent.closed != undefined && self.$parent.closed == 2){
                                self.formOpen=false;
                            }else{
                                if (expVar == 'returned'){
                                    self.formOpen=false;
                                }else{
                                    self.chargesArr = [];
                                    self.formOpen=true;
                                }
                            }

                            if (expVar != 'returned'){
                                self.chargesArrInput = [];
                                for(var i=0;i<data.contract_charge.length;i++){
                                    self.chargesArrInput.push({
                                        id:0,
                                        charge:{text:data.contract_charge[i].charge_name,value:data.contract_charge[i].charge_id},
                                        misc_charge_date:data.contract_charge[i].from_date != undefined ? data.contract_charge[i].from_date : (data.contract_charge[i].misc_charge_date != undefined ? data.contract_charge[i].misc_charge_date : exp),
                                        misc_charge_to_date : data.contract_charge[i].to_date != undefined ? data.contract_charge[i].to_date : (data.contract_charge[i].misc_charge_to_date != undefined ? data.contract_charge[i].misc_charge_date : moment(exp).endOf('month').format('MM/DD/YYYY')),
                                        charge_to_date_error_msg:'',
                                        quantity:data.contract_charge[i].quantity,
                                        rate:data.contract_charge[i].rate,
                                        amount:data.contract_charge[i].amount,
                                        comment:"",
                                        charge_error_msg: "",
                                        charge_date_error_msg:"",
                                        quantity_error_msg: "",
                                        rate_error_msg: "",
                                        amount_error_msg: "",
                                        status:'0',
                                        isDisable:true,
                                        view_comment: (data.contract_charge[i].view_comment == 0) ? false : true,
                                    })
                                }
                                
                            }
                            

                            if (data.charge_date != undefined){
                                self.charge_date = data.charge_date;
                            }else{
                                self.charge_date = moment().format('MM/DD/YYYY');
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'contract-view-data')
                    }
                });
            },
            loadCharge(flag){

                var self = this;
                self.formOpen=true;
                if(flag=='update'){
                    // for(var i=0;i<self.chargesArr.length;i++){
                    //     //only allow to update which are not billed.
                    //     // if ( self.chargesArr[i].status == 0 ) {

                    //         self.chargesArrInput.push({
                    //             id:self.chargesArr[i].id,
                    //             charge:{text:self.chargesArr[i].charge_name,value:self.chargesArr[i].charge_id},
                    //             misc_charge_date:moment(self.chargesArr[i].misc_charge_date).format('MM/DD/YYYY'),
                    //             misc_charge_to_date : moment(self.chargesArr[i].misc_charge_to_date).format('MM/DD/YYYY'),
                    //             charge_to_date_error_msg:'',
                    //             charge_date_error_msg:'',
                    //             quantity:self.chargesArr[i].quantity,
                    //             rate:self.chargesArr[i].rate,
                    //             amount:self.chargesArr[i].amount,
                    //             comment:self.chargesArr[i].comment,
                    //             view_comment: (self.chargesArr[i].view_comment == 1) ? true:false,
                    //             charge_error_msg: "",
                    //             quantity_error_msg: "",
                    //             rate_error_msg: "",
                    //             amount_error_msg: "",
                    //             status:self.chargesArr[i].status,
                    //             isDisable:false
                    //         })
                    //     // }
                    // }
                }else{
                        self.chargesArrInput.push({
                            id:0,
                            charge:null,
                            misc_charge_date:"",
                            misc_charge_to_date :"",
                            charge_to_date_error_msg:'',
                            charge_date_error_msg:'',
                            quantity:0,
                            rate:0,
                            amount:0,
                            comment:"",
                            view_comment:false,
                            charge_error_msg: "",
                            quantity_error_msg: "",
                            rate_error_msg: "",
                            amount_error_msg: "",
                            status:'0',
                            isDisable:false
                        })
                }

            },
            addLine () {

                var self = this;
                console.log(self.chargesArrInput);
                var index = self.chargesArrInput.length-1;

                self.chargesArrInput[index].charge_error_msg = "";
                self.chargesArrInput[index].quantity_error_msg = "";
                self.chargesArrInput[index].rate_error_msg = "";
                self.chargesArrInput[index].amount_error_msg = "";
                self.chargesArrInput[index].charge_date_error_msg = "";

                // var sectionValue = $($event.target).closest('.validation-msg').find('.section-value').val();

                if ( self.chargesArrInput[index].charge != null && self.chargesArrInput[index].charge != ""
                 && self.chargesArrInput[index].quantity != null && self.chargesArrInput[index].quantity != "" && self.chargesArrInput[index].quantity != 0
                && self.chargesArrInput[index].rate != null && self.chargesArrInput[index].rate != "" && self.chargesArrInput[index].rate != 0
                 && self.chargesArrInput[index].amount != null && self.chargesArrInput[index].amount != "" && self.chargesArrInput[index].amount != 0
                 && self.chargesArrInput[index].misc_charge_date != null && self.chargesArrInput[index].misc_charge_date != "" && self.chargesArrInput[index].misc_charge_to_date != null && self.chargesArrInput[index].misc_charge_to_date != ""
                 ) {

                    self.chargesArrInput.push({
                            id:0,
                            charge:null,
                            misc_charge_date:"",
                            misc_charge_to_date :"",
                            charge_to_date_error_msg:'',
                            charge_date_error_msg:'',
                            quantity:0,
                            rate:0,
                            amount:0,
                            comment:"",
                            charge_error_msg: "",
                            quantity_error_msg: "",
                            rate_error_msg: "",
                            amount_error_msg: "",
                            status:'0',
                            isDisable:false
                        })

                } else {

                    if (self.chargesArrInput[index].charge == null || !self.chargesArrInput[index].charge.value) {
                        self.chargesArrInput[index].charge_error_msg = "Charge Required.";
                    }

                    if (self.chargesArrInput[index].misc_charge_date == null || self.chargesArrInput[index].misc_charge_date =='' ) {
                        self.chargesArrInput[index].charge_date_error_msg = "From Date Required.";
                    }

                    if (self.chargesArrInput[index].misc_charge_to_date == null || self.chargesArrInput[index].misc_charge_to_date =='' ) {
                        self.chargesArrInput[index].charge_to_date_error_msg = "To Date Required.";
                    }

                    if (self.chargesArrInput[index].quantity == null || self.chargesArrInput[index].quantity=='' || self.chargesArrInput[index].quantity != 0 ) {
                        self.chargesArrInput[index].quantity_error_msg = "Quantity Required.";
                    }

                     if (self.chargesArrInput[index].rate == null || self.chargesArrInput[index].rate=='' || self.chargesArrInput[index].rate != 0 ) {
                        self.chargesArrInput[index].rate_error_msg = "Rate Required.";
                    }

                     if (self.chargesArrInput[index].amount == null || self.chargesArrInput[index].amount=='' || self.chargesArrInput[index].amount != 0 ) {
                        self.chargesArrInput[index].amount_error_msg = "Amount Required.";
                    }


                }

            },
            removeLine (lineId,id,status) {
                var self = this;
                if ( id == 0 ) {
                    //if (!self.blockRemoval)
                    self.chargesArrInput.splice(lineId, 1)
                } else if( status == 1){
                    self.$swal('','Charges ones billed cannot be removed ','info');
                    return;
                }else {
                    $("#updateChargeButton").prop('disabled',true);
                    $("#updateChargeButton1").prop('disabled',true);
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/remove-contract-asset-miscellaneous-charges",
                        type: "POST",
                        data: {'id':id},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            $("#updateChargeButton").prop('disabled',false);
                            $("#updateChargeButton1").prop('disabled',false);
                            self.loading = false;
                            if (data.status == "success" ) {
                                self.chargesArrInput.splice(lineId, 1);

                            }

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            $("#updateChargeButton").prop('disabled',false);
                            $("#updateChargeButton1").prop('disabled',false);
                        },
                    });
                }
                if (!self.chargesArrInput.length || self.chargesArrInput.length == 1){
                    if ( self.chargesArrInput[0].id > 0 && self.$parent.activetab != 1){
                        // self.chargesArrInput.push({
                        //     id:0,
                        //     charge:null,
                        //     quantity:0,
                        //     rate:0,
                        //     amount:0,
                        //     comment:"",
                        //     charge_error_msg: "",
                        //     quantity_error_msg: "",
                        //     rate_error_msg: "",
                        //     amount_error_msg: "",
                        //     status:'0'
                        // })
                    }
                    // setTimeout(function(){
                    //     if (!self.chargesArrInput.length){
                    //         self.chargesArrInput.push({
                    //             id:0,
                    //             charge:null,
                    //             misc_charge_date:"",
                    //             misc_charge_to_date :"",
                    //             charge_to_date_error_msg:'',
                    //             charge_date_error_msg:'',
                    //             quantity:0,
                    //             rate:0,
                    //             amount:0,
                    //             comment:"",
                    //             view_comment:false,
                    //             charge_error_msg: "",
                    //             charge_date_error_msg:"",
                    //             quantity_error_msg: "",
                    //             rate_error_msg: "",
                    //             amount_error_msg: "",
                    //             status:'0',
                    //             isDisable:false
                    //         })
                    //     }
                    // },500);

                }

            },
            createMiscCharge(from){
                var self = this;
                var error = false;
                var miscChargeArr = [];
                var miscChargeDateArr = [];
                var path = window.location.pathname;
                var segments = path.split("/");
                var checkNumber = /^[0-9]+(\.[0-9]+)?$/;

                    for (var i=0; i<self.chargesArrInput.length; i++) {

                        self.chargesArrInput[i].charge_error_msg = "";
                        self.chargesArrInput[i].charge_date_error_msg = "";
                        self.chargesArrInput[i].quantity_error_msg = "";
                        self.chargesArrInput[i].rate_error_msg = "";
                        self.chargesArrInput[i].amount_error_msg = "";
                        self.chargesArrInput[i].charge_to_date_error_msg = "";

                        if (self.chargesArrInput[i].status != undefined && self.chargesArrInput[i].status == 1){
                            continue;
                        }

                        if ( (self.chargesArrInput[i].status == undefined || self.chargesArrInput[i].status == 0 ) && self.chargesArrInput[i].charge != undefined && ($.inArray( self.chargesArrInput[i].charge.value , miscChargeArr ) != -1)
                              && self.chargesArrInput[i].misc_charge_date != null && ($.inArray( self.chargesArrInput[i].misc_charge_date , miscChargeDateArr ) != -1)) {
                            self.chargesArrInput[i].charge_error_msg = "Charge and its associated date has been already added.";
                            error = true;
                        }


                        if ( self.chargesArrInput[i].charge == null || !self.chargesArrInput[i].charge.value ) {

                            self.chargesArrInput[i].charge_error_msg = "Charge Rate Required.";
                            error = true;
                        } else {
                            miscChargeArr.push(self.chargesArrInput[i].charge.value);
                        }

                        if ( self.chargesArrInput[i].misc_charge_date == null || self.chargesArrInput[i].misc_charge_date == "") {

                            self.chargesArrInput[i].charge_date_error_msg = "Charge From Date Required.";
                            error = true;
                        } else {
                            miscChargeDateArr.push(self.chargesArrInput[i].misc_charge_date);
                        }

                        if ( self.chargesArrInput[i].misc_charge_to_date == null || self.chargesArrInput[i].misc_charge_to_date == "") {

                            self.chargesArrInput[i].charge_to_date_error_msg = "Charge To Date Required.";
                            error = true;
                        }

                        if (self.chargesArrInput[i].quantity == null || self.chargesArrInput[i].quantity=='' ) {
                            self.chargesArrInput[i].quantity_error_msg = "Quantity Required.";
                            error = true;
                        }

                        if (self.chargesArrInput[i].rate == null || self.chargesArrInput[i].rate=='' ) {
                            self.chargesArrInput[i].rate_error_msg = "Rate Required.";
                            error = true;
                        }

                        if (self.chargesArrInput[i].amount == null || self.chargesArrInput[i].amount=='' ) {
                            self.chargesArrInput[i].amount_error_msg = "Amount Required.";
                            error = true;
                        }


                    }

                  if (error==false) {

                    var fields = {
                                contract_asset_id:segments[3],
                                charge_arr: JSON.stringify(self.chargesArrInput),
                                flag:self.from,
                                charge_date:self.charge_date
                            };
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/contractassetdetail/charge/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;

                           if (data.status == "success") {
                                var path = window.location.pathname;

                                var segments = path.split("/");
                                self.formOpen=false;
                                self.chargesArrInput=[];
                                self.notBilled = false;
                                self.loadChargeData('','');

                                if (from == 'return'){
                                    self.$parent.createContractAssetReading('final');
                                }

                            }
                            else {
                                if (from == 'return'){
                                    self.$parent.createContractAssetReading('error');
                                }
                                if (data.content.length > 0) {
                                    var err = "<ul>";
                                    $(".alert-contract").empty();

                                    for (var i = 0; i < data.content.length; i++) {
                                        err += "<li>" + data.content[i] + "</li>";
                                    }
                                    err += "</ul>";
                                    $(".alert-contract").append(err);
                                    $(".alert-contract").addClass("show");
                                    // $("#errorMsg").html(err);
                                    // $(".alert-warning").toggleClass("show");
                                    // setTimeout(function () {
                                        // $(".alert-warning").removeClass("show");
                                        // $(".alert-warning").addClass("hide");
                                    // }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (from == 'return'){
                                self.$parent.createContractAssetReading('error');
                            }
                            self.generateStatusCodeMessage(jqXHR,true,'contract-asset-detail-create')
                        }
                    });
                  }
            },

            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
            onchangeCharge:function(evt,charge,index){
                var self = this;
                console.log(charge);
                self.chargesArrInput[index].rate = charge.price;
                if (charge.text == 'DEF' || charge.text == 'Fuel'){
                    $.ajax({
                        url: process.env.ROOT_API + "/fetch-asset-feature-for-charge",
                        type: "GET",
                        data: {'vehicle_id':self.$parent.vehicle_id},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            if (data.status == "success" ) {
                                // self.chargesArrInput.splice(lineId, 1);
                                self.features = data.content;
                                if (self.features && self.features.length){

                                    self.features.forEach(function(val){
                                        // if (val.charge == 'DEF'){

                                        // }
                                        // alert(val.value+ '&&'+ charge.text +'&&'+ val.text);
                                        if (val.value && charge.text == 'DEF' && val.charge == 'DEF'){
                                            self.chargesArrInput[index].quantity = val.value;
                                        }
                                        if (val.value && charge.text == 'Fuel' && val.charge == 'FUS'){
                                            self.chargesArrInput[index].quantity = val.value;
                                        }
                                    })
                                    setTimeout(function(){

                                        self.calculateAmount(index);

                                    },500);
                                }
                            }

                        },
                        error: function (jqXHR, exception) {

                        },
                    });
                }
            },
            generateInvoice:function(){
                var self = this;
                if (confirm('Are you sure to generate invoice now for these charges ?')){
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/misccharges/invoice/create",
                        type: "POST",
                        data: {
                            id:self.$route.params.id,
                            from:self.from,
                            charge_date:self.charge_date
                        },
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.code == 201){
                                self.$swal('',data.message,'info');
                                return;
                            }
                            if (data.status == "success") {
                                var path = window.location.pathname;

                                var segments = path.split("/");
                                self.formOpen=false;
                                self.chargesArrInput=[];
                                self.loadChargeData('','');

                            }
                            else {
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'generate-misc-charge-invoice')
                        }
                    });
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ContractMiscellaneousChargeTabView.vue